// extracted by mini-css-extract-plugin
export default {"dialog":"Modal_dialog-T73","visible":"Modal_visible-kka","modalContent":"Modal_modalContent-NQx"};